// Sostituisce tutti gli spazi e gli & con '-' e rimuove gli altri caratteri non validi per i selettori

import slugify from "slugify";

// https://stackoverflow.com/questions/448981/which-characters-are-valid-in-css-class-names-selectors
const ID_REGEX = /^[0-9]/;
const anchorify = (string) => {
  const tempString = string
    ? slugify(string, { strict: false, remove: /[^A-Za-z0-9\s-]/g, lower: true })
    : string;
  const result = tempString && ID_REGEX.test(tempString) ? "_" + tempString : tempString;
  return result;
  //   .replace(/[\s&]/g, "-")
  //   .replace(/[~!@$%^*()+=,./';:"?><[\]\\{}|`#]/g, "")
  // .toLowerCase()
};

export default anchorify;
